'use client'
import { PaginationSkeleton } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

/** Sized for a full page of reallocations, which most visited V1 vaults have. */
const TableReallocateLoading = () => {
  return (
    <div className="gap-xs flex flex-col">
      <Skeleton className="h-[259px] w-[100%] rounded-[20px]" />
      <PaginationSkeleton />
    </div>
  )
}

export default TableReallocateLoading
